import { render, staticRenderFns } from "./NavSection.vue?vue&type=template&id=23adc434&"
import script from "./NavSection.vue?vue&type=script&lang=js&"
export * from "./NavSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports